import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "x-icon",
  "use": "x-icon-usage",
  "viewBox": "0 0 34 34",
  "content": "<symbol viewBox=\"0 0 34 34\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"x-icon\">\r\n\t<path d=\"M24.3312 4.25H28.2434L19.6987 15.0506L29.75 29.75H21.8822L15.7154 20.837L8.66681 29.75H4.74831L13.8858 18.1948L4.25 4.25H12.3176L17.8861 12.3966L24.3312 4.25ZM22.9574 27.163H25.1239L11.1371 6.70186H8.81025L22.9574 27.163Z\" fill=\"#161D28\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol